export type SeedType =
  | "product"
  | "photography"
  | "scene"
  | "composition"
  | "casting";

export interface PickedSeed {
  type: SeedType;
  name: string;
  thumbnailUrl?: string;
  id?: string;
  imageUrl?: string | null;
  vendorProductId?: string;
  vendorVariantId?: string;
  variantTitle?: string;
  format?: string;
  placement?: string;
  tags?: string[];
  instructions?: Record<string, string>;
  notes?: string;
}

export type PickedSeeds = Partial<Record<SeedType, PickedSeed>>;

export const SEED_TYPE_ORDER: readonly SeedType[] = [
  "product",
  "scene",
  "photography",
  "casting",
  "composition",
];

export const SEED_TYPE_LABELS: Record<SeedType, string> = {
  product: "Product",
  photography: "Photography",
  scene: "Scene",
  composition: "Composition",
  casting: "Casting",
};
